import { Board } from '@/components/Board';

export default {
  path: '/board/',
  component: Board,
  meta: {
    text: '掲示板',
  },
};
